import { GenIcon } from '../helpers/IconBase.es.js';

const UploadOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.5652 2.55469C7.84465 2.55469 4.78711 5.34996 4.35396 8.95157C2.79571 9.57021 1.68481 11.0832 1.68481 12.8699C1.68481 15.205 3.57799 17.0982 5.91308 17.0982H8.52177C8.93598 17.0982 9.27177 16.7624 9.27177 16.3482C9.27177 15.934 8.93598 15.5982 8.52177 15.5982H5.91308C4.40642 15.5982 3.18481 14.3766 3.18481 12.8699C3.18481 11.6013 4.0587 10.5374 5.24353 10.2369C5.56317 10.1558 5.79237 9.87549 5.80829 9.54612C5.9561 6.48823 8.47424 4.05469 11.5652 4.05469C14.6218 4.05469 17.119 6.43375 17.3169 9.44344C17.3429 9.83977 17.6734 10.1471 18.0706 10.1442C19.599 10.1333 20.8153 11.37 20.8153 12.8699C20.8153 14.3766 19.5936 15.5982 18.087 15.5982H15.4783C15.0641 15.5982 14.7283 15.934 14.7283 16.3482C14.7283 16.7624 15.0641 17.0982 15.4783 17.0982H18.087C20.4221 17.0982 22.3153 15.205 22.3153 12.8699C22.3153 10.7762 20.7831 9.0075 18.7414 8.69362C18.1972 5.21667 15.1963 2.55469 11.5652 2.55469ZM12.503 8.83526C12.37 8.71491 12.1936 8.6416 12 8.6416H12C11.792 8.6416 11.6037 8.72634 11.4678 8.86319L8.86101 11.47C8.56812 11.7629 8.56812 12.2377 8.86101 12.5306C9.15391 12.8235 9.62878 12.8235 9.92167 12.5306L11.25 11.2023V20.6959C11.25 21.1102 11.5858 21.4459 12 21.4459C12.4142 21.4459 12.75 21.1102 12.75 20.6959V11.2023L14.0784 12.5306C14.3713 12.8235 14.8462 12.8235 15.1391 12.5306C15.432 12.2377 15.432 11.7629 15.1391 11.47L12.5304 8.86127C12.5214 8.85235 12.5123 8.84368 12.503 8.83526Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { UploadOutlined };
